// import crypto from 'crypto'
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import authToken from '~/mixins/authToken';
import { PLAN_DECODE_MAP } from '~/assets/data/plan-maps.json';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
import getPlans from '~/utils/plans';
import policies from '~/assets/data/policies.json';
import DisclosureModal from '~/components/members-area/DisclosureModal';
export default {
  // middleware: 'members-auth',
  components: {
    LoadingOverlay,
    DisclosureModal
  },
  mixins: [authToken],
  layout: 'members-area',
  data() {
    return {
      // Boilerplate
      loaded: false,
      isDev: this.$config.environment === 'development' || this.$config.plaidEnv === 'sandbox',
      plaidEnv: this.$config.plaidEnv || 'production',
      isDemo: false,
      processing: true,
      error: null,
      errorContext: null,
      alternateFunnel: null,
      // Policy stuff
      confirmationPolicies: {
        ach_authorization: false,
        cardholder_agreement: false,
        patriot_cardholder_agreement: false
        // @DayFlo is this still used? i couldnt find a reference to it in code -@roland
      },
      viewDisclosure: {
        Patriot_Cardholder_Agreement: false,
        Cardholder_Agreement: false,
        FCRA_Notice: false,
        Military_Lending: false,
        ACH_Authorization: false
      },
      showDisclosure: false,
      disclosureFile: '',
      metadata: {
        first_name: '',
        last_name: '',
        account_last_four: '',
        plan_type: '',
        billing_cycle: '',
        basic_plan_cost: '',
        rewards_plan_cost: '',
        current_date: '',
        process_day: '',
        process_month: ''
      }
    };
  },
  head() {
    return {
      bodyAttrs: {}
    };
  },
  computed: {
    // watch and kick to /error
    showErrorStage() {
      return this.error && !this.processing;
    },
    showConfirmation() {
      return ['ach_authorization', 'cardholder_agreement'].includes(this.policyName);
    },
    achPolicyMetadata() {
      var _plans$PLAN_DECODE_MA;
      const plans = getPlans(this.alternateFunnel);
      const currentPlanCost = this.metadata.plan_cost ? this.metadata.plan_cost : (_plans$PLAN_DECODE_MA = plans[PLAN_DECODE_MAP[1][this.metadata.plan_type]]) === null || _plans$PLAN_DECODE_MA === void 0 ? void 0 : _plans$PLAN_DECODE_MA.price[PLAN_DECODE_MAP[0][this.metadata.billing_cycle]];

      // changes here should also be made in card.vue
      dayjs.extend(AdvancedFormat);
      return {
        first_name: this.metadata.first_name,
        // name at timestamp
        last_name: this.metadata.last_name,
        // name at timestamp
        account_last_four: this.metadata.account_last_four,
        plan_type: this.metadata.plan_type,
        billing_cycle: this.metadata.billing_cycle,
        basic_plan_cost: this.metadata.basic_plan_cost,
        rewards_plan_cost: this.metadata.rewards_plan_cost,
        // display only
        current_date: dayjs(this.metadata.date_of_signature).format('MMMM D, YYYY'),
        process_day: dayjs(this.metadata.process_day).format('Do'),
        process_month: this.metadata.billing_cycle === 'annual' ? `${dayjs(this.metadata.process_day).format('MMMM')} each year` : 'each month',
        raw_process_date: dayjs(this.metadata.process_day),
        formatted_process_date: dayjs(this.metadata.process_day).format('MMMM Do, YYYY'),
        formatted_plan_cost: currentPlanCost === null || currentPlanCost === void 0 ? void 0 : currentPlanCost.toFixed(2)
      };
    },
    confirmationPolicyMetadata() {
      return {
        recurring_ach_authorization: this.achPolicyMetadata,
        standing_ach_authorization: this.achPolicyMetadata,
        one_time_ach_authorization: this.achPolicyMetadata,
        cardholder_agreement: {
          first_name: this.metadata.first_name,
          // name at timestamp
          last_name: this.metadata.last_name // name at timestamp
        }
      };
    },
    metadataForCurrentPolicy() {
      console.log(this.confirmationPolicyMetadata[policies[this.disclosureFile]]);
      return this.confirmationPolicyMetadata[policies[this.disclosureFile]];
    },
    remappedPolicyDisclosureFile() {
      return Object.assign(...Object.entries(policies).map(([key, value]) => ({
        [value]: key
      })));
    }
  },
  watch: {
    error(err) {
      if (!err) {
        this.errorContext = {
          context: null
        };
        return;
      }
      this.formSubmitted = false;
      const isErr = err instanceof Error || err && err.stack && err.message;
      const casted = isErr ? err : new Error(JSON.stringify(err));
      if (this.errorContext) {
        Object.entries(this.errorContext).forEach(([key, value]) => {
          casted[key] = value;
        });
      }
      const id = this.$sentry.captureException(casted);
      console.error(`Agreements.vue error, sentry id ${id}`, err.message);
    }
  },
  mounted() {
    console.log(this.$route.query);
    const {
      id: policyId,
      policy: policyName
    } = this.$route.query;
    this.policyId = policyId;
    this.policyName = policyName;
    if (window.EXTRA_DEV) {
      this.isDev = true;
    }
    this.fetchPolicyMetadata();
  },
  errorCaptured(err, vm, info) {
    err.info = info;
    this.error = err;
    this.errorContext = {
      context: 'uncapturedExc'
    };
    return true;
  },
  methods: {
    showThisDisclosure(disc) {
      this.disclosureFile = disc;
      this.showDisclosure = true;
    },
    async fetchPolicyMetadata() {
      try {
        this.processing = true;
        const data = await this.$axios.$get('/api/members/policy/' + (this.policyName || this.policyId));
        this.metadata = data.policyMetadata;
        this.policy = this.policyName || data.policy;
        this.alternateFunnel = data.cohort;
        this.showThisDisclosure(this.remappedPolicyDisclosureFile[this.policy]);
        console.log(this.disclosureFile);

        // Don't remove - last step
        this.processing = false;
      } catch (err) {
        this.processing = false;
        this.errorContext = {
          context: 'fetchPolicyMetadata'
        };
        this.error = err;
      }
    },
    clearError() {
      this.errorContext = null;
      this.error = null;
      // window.location.reload()
    }
  }
};